export default {
  development: ['localhost', /^\w+$/],
  qa: [/^.*?-?qa-?.*?\.86borders\.com$/],
  uat: [/^.*?-?uat-?.*?\.86borders\.com$/],
  reg: [/^.*?-?reg-?.*?\.86borders\.com$/],
  dev: [/^.*?-?dev-?.*?\.86borders\.com$/],
}
